<!--IMAGE-SLIDE -->
<div class="row ttm-bgcolor-whiteecolor mt-2">
  <div class="carousel-container">
    <div
      id="carouselExampleControls"
      class="carousel slide"
      data-ride="carousel"
    >
      <div class="carousel-inner">
        <div
          *ngFor="let img of images1; let i = index"
          class="carousel-item"
          [class.active]="i === 0"
        >
          <img class="d-block" [src]="img.src" [alt]="img.alt" />
        </div>
      </div>
      <a
        class="carousel-control-prev text-danger"
        href="#carouselExampleControls"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon text-danger" aria-hidden="true"></span>
        <span class="sr-only text-danger">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleControls"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</div>
<!-- INFORMATION -->
<section class="ttm-row clearfix ttm-bgcolor-whiteecolor">
  <div class="row mt-1">
    <div class="col-lg text-center">
      <div class="section-title clearfix">
        <div class="container">
          <div class="col-lg text-center">
            <div class="section-title clearfix">
              <div class="container">
                <!-- section title -->
                <div class="title-header info-widget-content">
                  <h5 class="text-center title" style="font-size: 3em">
                    WELCOME TO<br />NISARGOPCHAR ASHRAM
                  </h5>
                  <h5 class="text-right title" style="font-size: 1.2em">
                    <b
                      >. . . . . Nature care, yog treatment center for your
                      healthy body</b
                    >
                  </h5>
                </div>
                <h2 style="text-align: right">
                  Along with Mahatma Gandhiji, the founder many great souls had
                  devoted their lives to uplift the declining health of the
                  rural community by being a part of Nisargopchar Ashram.
                  Prominent among them were Shri. Manibhai Desai, Shri. Balkoba
                  Bhave, Smt. Gangabehn Bhate, Shri. Vishnupant Gokhale, Smt.
                  Hoshyaribehn Bohare and Shri.Ganesh Behede. Their commitment,
                  simplicity and sincerity are left behind as a source of
                  inspiration for us.
                </h2>
              </div>
            </div>
            <!-- section title end -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg ttm-bgcolor-whiteecolor">
      <div class="col-lg mt-3 justify-content-center align-items-center">
        <!-- <div class="embed-responsive embed-responsive-16by9"> -->
        <div class="video-container">
          <video #videoPlayer class="video" loop>
            <!-- <source src="assets/Video/nisarg.mp4" type="video/mp4"> -->
            <source src="assets/Video/Without Audio.mp4" type="video/mp4" />
          </video>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>

  <!-- THERAPIES -->
  <div class="row mt-1">
    <div class="col-lg ttm-bgcolor-whiteecolor">
      <div class="col-lg mt-3 justify-content-center align-items-center">
        <img class="logo" src="assets/img/Home Slider/Male Therapy Center.JPG" />
      </div>
    </div>
    <div class="col-lg text-center mt-3">
      <div class="section-title clearfix">
        <div class="container">
          <h5 class="text-left" style="font-size: 2.5em">THERAPIES</h5>
          <div class="Vascular">
            <div class="title-desc mt-4 text-center">
              <h2 style="text-align: left">
                <strong>
                  Nature's Five-Fold Blessings - The Elemental Touch </strong
                ><br />
                The Treatment is based on the concept of Panchamahabhootas;
                <br />
                💧 Water - For cleansing, cooling, and renewing<br />
                🌬️ Air - For invigorating body and spirit<br />
                🌌 Space - For inner stillness and expansion<br />
                🌍 Earth - For grounding and detoxifying<br />
                🔥 Fire - For energy, transformation, and warmth<br />
                <br />
                ...... click for more
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- THERAPIES -->

  <!-- TREATMENTS -->
  <div class="row mt-1">
    <div class="col-lg text-center mt-3">
      <div class="section-title clearfix">
        <div class="container">
          <h5 class="text-right" style="font-size: 2.5em">TREATMENTS</h5>
          <div class="title-desc text-center">
            <h2 style="text-align: right">
              <strong>
                Movement, Touch, and Sun - Mechanical Pathways to Vitality </strong
              ><br />
              We harness nature's rhythm to unlock your inner vitality
              through:<br />
              Yoga & Asanas - Harmonizing body and breath 🧘‍♂️<br />
              Therapeutic Massage - Releasing tension, restoring flow 💆<br />
              Nature Walks - Reconnecting with the earth 🚶<br />
              Sunbaths - Absorbing the healing energy of sunlight ☀️<br />
              Natural Exercises - Encouraging strength and flexibility 🏋️<br />
              <br />
              ...... click for more
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg ttm-bgcolor-whiteecolor">
      <div class="col-lg justify-content-center align-items-center">
        <img class="logo" src="assets/img/Home Slider/Female Therapy Center.JPG" />
      </div>
    </div>
  </div>
  <!-- TREATMENTS -->

  <!-- FACILITIES -->
  <div class="row mt-1">
    <div class="col-lg ttm-bgcolor-whiteecolor">
      <div class="col-lg justify-content-center align-items-center">
        <img class="logo" src="assets/img/Home Slider/Yoga Hall-1 I.JPG" />
      </div>
    </div>
    <div class="col-lg text-center mt-3">
      <div class="section-title clearfix">
        <div class="container">
          <h5 class="text-left" style="font-size: 2.5em">THE INNER SANCTUARY</h5>
          <div class="title-desc text-center">
            <h2 style="text-align: left">
              <strong>Healing the Mind & Spirit - True wellness flows from within.</strong>
               <br />
              We offer time-honored mental and spiritual therapies that awaken clarity, calm, and purpose:<br />
              ✨ Scientific Relaxation - Calming the nervous system and melting away stress<br />
              🧘‍♀️ Meditation Practices - Awakening awareness through silence and stillness<br />
              🌀 Suggestion Therapy - Reprogramming the subconscious with positivity<br />
              🌟 Affirmations & Prayer - Invoking healing through intention and faith<br />
              <br />
              ...... click for more
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- FACILITIES -->

  <!-- TESTIMONIALS -->
    <div class="row mt-1">
    <div class="col-lg text-center mt-3">
      <div class="section-title clearfix">
        <div class="container">
          <h5 class="text-right" style="font-size: 2.5em">TUNE WITH NATURE</h5>
          <div class="title-desc text-center">
            <h2 style="text-align: right">
              <strong>
              Healing begins when we return to our roots. Every breath - step - thought is a sacred act in our journey back to nature.</strong><br />
              Eating mindfully 🌿<br />
              Breathing deeply 🌬️<br />
              Working consciously 🧘<br />
              Resting peacefully 😌<br />
              Thinking positively 🕊️<br />
              Living ethically 🌼<br />
              <br />
              ...... click for more
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg ttm-bgcolor-whiteecolor">
      <div class="col-lg justify-content-center align-items-center">
        <img class="logo" src="assets/img/Home Slider/Yoga Hall-2 O.JPG" />
      </div>
    </div>
  </div>
  <!--<div class="row mt-1">
    <div class="col-lg text-center mt-3">
      <div class="section-title clearfix">
        <h4 class="text-center" style="font-size: 2.5em">LIVING IN TUNE WITH NATURE</h4>
        <div class="title-desc text-center">
          <div class="row container-fluid">
            <div class="col">
              <div class="row">
                <div class="col-md" *ngFor="let textt of textt.slice(0, 1)">
                  <h2>{{ textt.feedback }}</h2>
                  <h3>
                    <strong>{{ textt.Name }}</strong>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg ttm-bgcolor-whiteecolor">
      <div class="col-lg d-flex justify-content-center align-items-center">
        <img class="logo" src="assets/img/Testomonial.jpg" />
      </div>
    </div>
  </div> -->
  <!-- TESTIMONIALS -->
</section>
<!-- INFORMATION -->

<!-- green-row -->
<div class="mt-1 clearfix">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-2">
          <div class="title-header">
            <!-- <h2 class="section-title mb-35 clearfix d-flex justify-content-start">-Testimonial</h2> -->
            <h2
              class="title d-flex justify-content-start"
              style="font-size: 40px; line-height: 90%"
            >
              What Our Clients Say!
            </h2>
          </div>
          <div _ngcontent-xch-c4="" class="testimonial-wrap py-4" dir="ltr">
            <div _ngcontent-xch-c4="" class="container">
              <div _ngcontent-xch-c4="" class="testimonial-slider">
                <div _ngcontent-xch-c4="" class="card shadow-box border p-4">
                  <ngx-slick-carousel
                    _ngcontent-xch-c4=""
                    ng-reflect-config="[object Object]"
                    class="slick-initialized slick-slider slick-dotted"
                  >
                    <div class="row container-fluid">
                      <div class="col">
                        <div
                          id="multiitemcarousel1"
                          class="carousel1 slide mt-4 align-items-right"
                          data-ride="carousel"
                        >
                          <div class="carousel-inner1">
                            <div
                              *ngFor="
                                let text of text.slice(0, 1);
                                let i = index
                              "
                              class="carousel-item1"
                              [class.active]="i === 0"
                            >
                              <h1 style="font-family: Calibri">
                                <i>{{ text }}</i>
                              </h1>
                            </div>
                          </div>
                          <a
                            class="carousel-control-prev"
                            href="#multiitemcarousel1"
                            role="button"
                            data-slide="prev"
                            (click)="prevSlide($event)"
                          >
                            <span
                              class="carousel-control-prev-icon"
                              aria-hidden="true"
                            ></span>
                            <span class="sr-only">Previous</span>
                          </a>
                          <a
                            class="carousel-control-next"
                            href="#multiitemcarousel1"
                            role="button"
                            data-slide="next"
                            (click)="nextSlide($event)"
                          >
                            <span
                              class="carousel-control-next-icon"
                              aria-hidden="true"
                            ></span>
                            <span class="sr-only">Next</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </ngx-slick-carousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="">
  <div
    class="elementor-element mt-2 text-center"
    data-id="1e760b8"
    data-element_type="widget"
    data-widget_type="text-editor.default"
  >
    <div class="elementor-widget-container">
      <!-- Responsive container for the map -->
      <div class="map-container">
        <iframe
          loading="lazy"
          style="border: 0; width: 100%; height: 450px"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.796385024599!2d74.13082399999999!3d18.492880000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2e0c836fc0b73%3A0xcce595bfddbf52fb!2sNisargopchar+Ashram!5e0!3m2!1sen!2sin!4v1437116886614"
          width="100%"
          height="100%"
          frameborder="0"
          allowfullscreen="allowfullscreen"
          data-rocket-lazyload="fitvidscompatible"
          class="lazyloaded"
          data-ll-status="loaded"
        ></iframe>
      </div>
      <!-- For browsers with JS disabled -->
      <noscript>
        <iframe
          style="border: 0"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.796385024599!2d74.13082399999999!3d18.492880000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2e0c836fc0b73%3A0xcce595bfddbf52fb!2sNisargopchar+Ashram!5e0!3m2!1sen!2sin!4v1437116886614"
          width="100%"
          height="450"
          frameborder="0"
          allowfullscreen="allowfullscreen"
        ></iframe>
      </noscript>
    </div>
  </div>
</div>